import styled from "@emotion/styled"

const Paragraph = styled.p`
    max-width: 800px;
`

export default Paragraph
